import moment from "moment";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import defaultavatar from "../../asset/defaultavatar.png";
import { useProfileStore } from "./state";

export const PektaBanner = () => {
  let navigate = useNavigate();

  return (
    <div className="bg-green-200 rounded-md shadow-2xl flex  lg:w-1/3 sm:w-96 px-10  mb-4 p-4 justify-between">
      <div className="font-semibold text-center w-32 ">
        Permohonan PEKTA dibuka
      </div>
      <div className="pl-5">
        <button
          onClick={() => navigate("/pekta-application")}
          className=" bg-lime-700 text-white rounded-md text-base w-40 lg:w-32 px-2 h-12  lg:whitespace-nowrap"
        >
          Mohon PEKTA
        </button>
      </div>
    </div>
  );
};

export const PektaProgressApplication = ({
  appRole,
  processed,
  screening,
  approve,
  testProgress,
  ulasan,
}) => {
  let banner;
  let status;

  // Helper to render Ulasan row, if present
  const UlasanRow = ({ ulasan }) => {
    if (typeof ulasan === "undefined") return null; // Hide if not present in response
    const text = ulasan === null || ulasan === "" ? "Tiada" : ulasan;
    return (
      <div className="flex flex-row justify-between mt-1">
        <div className="text-gray-500">Ulasan</div>
        <div className=" italic">{text}</div>
      </div>
    );
  };

  if (processed === "pending") {
    status = "Permohonan Telah Dihantar";
  } else if (processed === "processing") {
    status = "Dalam Proses";
  } else if (processed === "interview") {
    status = "Panggilan Temuduga";
  } else if (processed === "approved") {
    status = "Diluluskan";
  } else if (processed === "rejected") {
    status = "Ditolak";
  }

  if (processed === "pending") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Saringan</div>
          <div className="italic">{screening}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Keputusan</div>
          <div className=" italic">{approve}</div>
        </div>
        <UlasanRow ulasan={ulasan} />
      </div>
    );
  } else if (processed === "processing") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Saringan</div>
          <div className="italic">{screening}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Ujian</div>
          <div className=" italic ">{testProgress}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Keputusan</div>
          <div className=" italic">{approve}</div>
        </div>
        <UlasanRow ulasan={ulasan} />
      </div>
    );
  } else if (processed === "interview") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
      </div>
    );
  } else if (processed === "rejected") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
      </div>
    );
  } else if (processed === "approved") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        {/* Hide Keputusan when approved */}
      </div>
    );
  } else {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-center">
          <div className="text-gray-500">Tiada permohonan</div>
        </div>
        <div></div>
      </div>
    );
  }
  return <>{banner}</>;
};

export const KatamProgressApplication = ({
  appRole,
  processed,
  screening,
  approve,
  testProgress,
  expiry,
  katamEnd,
  katamEnable,
  ulasan,
}) => {
  let banner;
  let status;

  // Helper to render Ulasan row, if present
  const UlasanRow = ({ ulasan }) => {
    if (typeof ulasan === "undefined") return null; // Hide if not present in response
    const text = ulasan === null || ulasan === "" ? "Ulasan Tiada" : ulasan;
    return (
      <div className="flex flex-row justify-between mt-1">
        <div className="text-gray-500">Ulasan</div>
        <div className=" italic">{text}</div>
      </div>
    );
  };
  if (processed === "pending") {
    status = "Permohonan Telah Dihantar";
  } else if (processed === "processing") {
    status = "Dalam Proses";
  } else if (processed === "interview") {
    status = "Panggilan Temuduga";
  } else if (processed === "approved") {
    status = "Diluluskan";
  } else if (processed === "rejected") {
    status = "Ditolak";
  }
  if (processed === "pending") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Saringan</div>
          <div className="italic">{screening}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Keputusan</div>
          <div className=" italic">{approve}</div>
        </div>
        <UlasanRow ulasan={ulasan} />
      </div>
    );
  } else if (processed === "processing") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Saringan</div>
          <div className="italic">{screening}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Ujian</div>
          <div className=" italic ">{testProgress}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Keputusan</div>
          <div className=" italic">{approve}</div>
        </div>
        <UlasanRow ulasan={ulasan} />
      </div>
    );
  } else if (processed === "interview") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
      </div>
    );
  } else if (
    expiry === true &&
    processed === "approved" &&
    katamEnable === true
  ) {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-center">
          <div className="text-gray-500">Tiada permohonan</div>
        </div>
        <div></div>
      </div>
    );
  } else if (processed === "rejected") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
      </div>
    );
  } else if (processed === "approved") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        {/* Hide Keputusan when approved */}
      </div>
    );
  } else {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-center">
          <div className="text-gray-500">Tiada permohonan</div>
        </div>
        <div></div>
      </div>
    );
  }
  return <>{banner}</>;
};
export const PihtasProgressApplication = ({
  appRole,
  processed,
  screening,
  approve,
  testProgress,
  expiry,
  katamEnd,
  katamStart,
  created,
  ulasan,
}) => {
  let banner;
  let status;
  // Helper to render Ulasan row, if present
  const UlasanRow = ({ ulasan }) => {
    if (typeof ulasan === "undefined") return null; // Hide if not present in response
    const text = ulasan === null || ulasan === "" ? "Ulasan Tiada" : ulasan;
    return (
      <div className="flex flex-row justify-between mt-1">
        <div className="text-gray-500">Ulasan</div>
        <div className=" italic">{text}</div>
      </div>
    );
  };
  if (processed === "pending") {
    status = "Permohonan Telah Dihantar";
  } else if (processed === "processing") {
    status = "Dalam Proses";
  } else if (processed === "interview") {
    status = "Panggilan Temuduga";
  } else if (processed === "approved") {
    status = "Diluluskan";
  } else if (processed === "rejected") {
    status = "Ditolak";
  }

  if (
    expiry !== katamEnd ||
    (expiry === katamEnd && moment(created).isBefore(katamStart) === true)
  ) {
    return (
      <>
        <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
          <h1 className="text-xl font-semibold flex mb-4">
            Status Permohonan {appRole}
          </h1>
          <div className="flex flex-row justify-center">
            <div className="text-gray-500">Tiada permohonan</div>
          </div>
          <div></div>
        </div>
      </>
    );
  }

  if (processed === "pending") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Saringan</div>
          <div className="italic">{screening}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Keputusan</div>
          <div className=" italic">{approve}</div>
        </div>
        <UlasanRow ulasan={ulasan} />
      </div>
    );
  } else if (processed === "processing") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Saringan</div>
          <div className="italic">{screening}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Ujian</div>
          <div className=" italic ">{testProgress}</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Keputusan</div>
          <div className=" italic">{approve}</div>
        </div>
        <UlasanRow ulasan={ulasan} />
      </div>
    );
  } else if (processed === "interview") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
      </div>
    );
  } else if (
    (expiry !== katamEnd && processed === "approved") ||
    (moment(created).isBefore(katamStart) === true && processed === "approved")
  ) {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-center">
          <div className="text-gray-500">Tiada permohonan</div>
        </div>
        <div></div>
      </div>
    );
  } else if (processed === "rejected") {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
      </div>
    );
  } else if (processed === "approved" && created > katamStart) {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-between">
          <div className="text-gray-500">Permohonan</div>
          <div className=" italic ">{status}</div>
        </div>
        {/* Hide Keputusan when approved */}
      </div>
    );
  } else {
    banner = (
      <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
        <h1 className="text-xl font-semibold flex mb-4">
          Status Permohonan {appRole}
        </h1>
        <div className="flex flex-row justify-center">
          <div className="text-gray-500">Tiada permohonan</div>
        </div>
        <div></div>
      </div>
    );
  }
  return <>{banner}</>;
};

export const ProgressApplication = ({
  appRole,
  processed,
  screening,
  approve,
  testProgress,
  ulasan,
}) => {
  return (
    <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
      <h1 className="text-xl font-semibold flex mb-4">
        Status Permohonan {appRole}
      </h1>
      <div className="flex flex-row justify-between">
        <div className="text-gray-500">Permohonan</div>
        <div className=" italic ">{processed}</div>
      </div>
      <div className="flex flex-row justify-between">
        <div className="text-gray-500">Saringan</div>
        <div className="italic">{screening}</div>
      </div>
      {testProgress}
      <div className="flex flex-row justify-between">
        <div className="text-gray-500">Keputusan</div>
        <div className=" italic">{approve}</div>
      </div>
    </div>
  );
};

export const InterviewApplication = ({ appRole, processed, approve }) => {
  return (
    <div className="bg-white rounded-md shadow-2xl lg:w-1/3  md:w-3/5  px-10 mb-4 p-4 flex flex-col">
      <h1 className="text-xl font-semibold flex mb-4">
        Status Permohonan {appRole}
      </h1>
      <div className="flex flex-row justify-between">
        <div className="text-gray-500">Permohonan</div>
        <div className=" italic ">{processed}</div>
      </div>

      <div className="flex flex-row justify-between">
        <div className="text-gray-500">Keputusan</div>
        <div className=" italic">{approve}</div>
      </div>
    </div>
  );
};

export const Approved = ({ role, activation, pektaID, katamAlert, status }) => {
  return (
    <div className="bg-white rounded-md shadow-2xl flex lg:w-1/3 sm:w-96 max-w-4xl mb-4 p-4 mt-10">
      <div className="flex flex-row">
        <div className="flex flex-col">
          <div className="flex flex-row">
            <div className="font-semibold text-xl">{role}</div>
            <div className="ml-1">{activation}</div>
          </div>

          <div className="flex flex-col font-medium text-sm">
            <div className="flex">PEKTA ID: {pektaID}</div>
          </div>
        </div>

        <button
          disabled={false}
          className="bg-white hover:bg-gray-200 text-gray-800 font-semibold border-2 py-1 px-4 rounded ml-10 text-sm"
          onClick={() => katamAlert(status)}
        >
          <svg
            className="w-full h-4 mr-2 justify-center items-center"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path className="" d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
          </svg>
          <span>Muat Turun Kad</span>
        </button>
      </div>
    </div>
  );
};

export const ExpiredBanner = ({ katamExist, expiredState }) => {
  let navigate = useNavigate();

  if (katamExist === "yes") {
    expiredState = true;
  }

  return (
    <div className="bg-green-200 rounded-md shadow-2xl flex lg:w-1/3 sm:w-96 max-w-4xl mb-4 p-4 flex-row">
      <div className="font-semibold mr-8">Permohonan KATAM telah dibuka</div>
      <button
        className="ml-18 bg-lime-700 text-white rounded-md text-base lg:h-8 sm:h-16 w-32"
        onClick={() => navigate("/katam-application")}
      >
        Mohon KATAM
      </button>
    </div>
  );
};

export const KatamBanner = ({ katamExist, expiredState }) => {
  let navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const { profile } = useProfileStore();

  // Get userToken from localStorage (same as in header)
  var CryptoJS = require("crypto-js");
  let login = JSON.parse(localStorage.getItem("login"));
  let userToken = "";
  try {
    if (
      login &&
      login.state &&
      login.state.login &&
      login.state.login.jwtToken
    ) {
      let bytes = CryptoJS.AES.decrypt(
        login.state.login.jwtToken.toString(),
        `${process.env.SECRET_KEY}`
      );
      userToken = bytes.toString(CryptoJS.enc.Utf8);
    }
  } catch (e) {}

  // Use profile.gambar from Zustand store
  let isDefaultAvatar =
    profile.gambar === defaultavatar ||
    (profile.gambar && profile.gambar.includes("defaultavatar.png"));

  if (katamExist === "no") {
    expiredState = true;
  }

  const handleMohonClick = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  // FOR PRODUCTION URL

  // const handleKemasKini = () => {
  //   const url = `https://e-bimbingan.tabunghaji.gov.my/user/profile/details?app=katam&verify-auth&token=${userToken}`;
  //   window.open(url, "_blank");
  //   setModalOpen(false);
  // };

  const handleKemasKini = () => {
    const url = `https://e-bimbingan.tabunghaji.gov.my/verify-auth-pekta?app=katam&verify-auth&token=${userToken}`;
    window.location.href = url;
    setModalOpen(false);
  };

  const handleTeruskan = () => {
    setModalOpen(false);
    navigate("/katam-application");
  };

  return (
    <>
      <div className="bg-green-200 rounded-md shadow-2xl flex  lg:w-1/3 sm:w-96 px-10  mb-4 p-4 justify-between">
        <div className="ont-semibold text-center w-32">
          Permohonan KATAM dibuka
        </div>
        <div className="pl-5">
          <button
            className="bg-lime-700 text-white rounded-md text-base w-40 lg:w-32 px-2 h-12  lg:whitespace-nowrap"
            onClick={handleMohonClick}
          >
            Mohon KATAM
          </button>
        </div>
      </div>
      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close (X) button */}
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none"
              onClick={() => setModalOpen(false)}
              aria-label="Tutup"
            >
              &times;
            </button>
            <div className="mb-6 text-lg font-semibold text-center">
              {isDefaultAvatar
                ? "Sila kemas kini maklumat dan muat naik gambar profil sebelum memohon KATAM."
                : "Sila semak dan kemas kini maklumat diri anda sekiranya terdapat perubahan sebelum memohon KATAM."}
            </div>
            <div className="flex flex-row gap-4 justify-center">
              <button
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 font-medium"
                onClick={handleKemasKini}
              >
                Kemas Kini Maklumat
              </button>
              {!isDefaultAvatar && (
                <button
                  className="bg-lime-700 text-white px-4 py-2 rounded hover:bg-lime-800 font-medium"
                  onClick={handleTeruskan}
                >
                  Teruskan Permohonan
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const RejectedApplication = ({ appRole, processed }) => {
  return (
    <div className="bg-white rounded-md shadow-2xl lg:w-1/3 sm:w-96 max-w-4xl mb-4 p-4 flex flex-col">
      <h1 className="text-xl font-semibold flex mb-4">
        Status Permohonan {appRole}
      </h1>
      <div className="flex flex-row justify-between">
        <div className="text-gray-500">Permohonan</div>
        <div className=" italic ">{processed}</div>
      </div>
      <div></div>
    </div>
  );
};

export const PektaTest = ({ testMark }) => {
  return (
    <div className="flex flex-row justify-between">
      <div className="text-gray-500">Ujian</div>
      <div className=" italic">{testMark}</div>
    </div>
  );
};

export const PihtasBanner = () => {
  let navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const { profile } = useProfileStore();

  // Get userToken from localStorage (same as in KatamBanner)
  var CryptoJS = require("crypto-js");
  let login = JSON.parse(localStorage.getItem("login"));
  let userToken = "";
  try {
    if (
      login &&
      login.state &&
      login.state.login &&
      login.state.login.jwtToken
    ) {
      let bytes = CryptoJS.AES.decrypt(
        login.state.login.jwtToken.toString(),
        `${process.env.SECRET_KEY}`
      );
      userToken = bytes.toString(CryptoJS.enc.Utf8);
    }
  } catch (e) {}

  // Use profile.gambar from Zustand store
  let isDefaultAvatar =
    profile.gambar === defaultavatar ||
    (profile.gambar && profile.gambar.includes("defaultavatar.png"));

  const handleMohonClick = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  // FOR STAGING URL (mirror logic from KatamBanner)
  const handleKemasKini = () => {
    const url = `https://the-bimbingan-staging.netlify.app/verify-auth-pekta?app=pihtas&verify-auth&token=${userToken}`;
    window.location.href = url;
    setModalOpen(false);
  };

  const handleTeruskan = () => {
    setModalOpen(false);
    navigate("/pihtas-application");
  };

  return (
    <>
      <div className="bg-green-200 rounded-md shadow-2xl flex  lg:w-1/3 sm:w-96 px-10  mb-4 p-4 justify-between">
        <div className="font-semibold text-center w-32 ">
          Permohonan PIHTAS dibuka
        </div>
        <div className="pl-5">
          <button
            className=" bg-lime-700 text-white rounded-md text-base w-40 lg:w-32 px-2 h-12  lg:whitespace-nowrap"
            onClick={handleMohonClick}
          >
            Mohon PIHTAS
          </button>
        </div>
      </div>
      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close (X) button */}
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none"
              onClick={() => setModalOpen(false)}
              aria-label="Tutup"
            >
              &times;
            </button>
            <div className="mb-6 text-lg font-semibold text-center">
              {isDefaultAvatar
                ? "Sila kemas kini maklumat dan muat naik gambar profil sebelum memohon PIHTAS."
                : "Sila semak dan kemas kini maklumat diri anda sekiranya terdapat perubahan sebelum memohon PIHTAS."}
            </div>
            <div className="flex flex-row gap-4 justify-center">
              <button
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 font-medium"
                onClick={handleKemasKini}
              >
                Kemas Kini Maklumat
              </button>
              {!isDefaultAvatar && (
                <button
                  className="bg-lime-700 text-white px-4 py-2 rounded hover:bg-lime-800 font-medium"
                  onClick={handleTeruskan}
                >
                  Teruskan Permohonan
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const noBanner = () => {
  return <div></div>;
};

export const Active = () => {
  return (
    <div className="bg-green-500 hover:bg-green-600 text-white rounded-xl p-1 text-sm">
      Aktif
    </div>
  );
};

export const Inactive = () => {
  return (
    <div className="bg-red-500 hover:bg-red-600 text-white rounded-xl p-1 text-sm">
      Tidak Aktif
    </div>
  );
};

export const luput = () => {
  return (
    <div className="bg-red-500 hover:bg-red-600 text-white rounded-xl p-1 text-sm">
      Luput
    </div>
  );
};

export const noPekta = () => {
  return (
    <div className="bg-gray-200 rounded-md shadow-2xl flex lg:w-1/3 sm:w-96 px-10 mb-4 p-4 justify-center">
      <strong className="font-semibold text-center w-auto">
        Tiada rekod permohonan PEKTA{" "}
      </strong>
    </div>
  );
};
